import { FormikProps } from "formik";
import { useContext } from "react";
import { PersonNewsletterAndDisclosureSettings } from "../../../../generated/data-contracts";
import {
  AvisHorizontalChoice,
  AvisSection,
} from "../../../shared/components/form";
import { AvisContext } from "../../../shared/context/AvisContext";

interface IRightsToDiscloseProps {
  bag: FormikProps<PersonNewsletterAndDisclosureSettings>;
  isReadOnly: boolean;
}

export function RightsToDisclose(props: Readonly<IRightsToDiscloseProps>) {
  const { bag, isReadOnly } = props;
  const { res } = useContext(AvisContext);

  return (
    <AvisSection
      title={res("authors_ContactInfoPage_RightsToDiscloseTitle")}
      classNameIn="contact-information-section"
    >
      <AvisHorizontalChoice
        bag={bag}
        bagFieldIn="disclosurePhone"
        rowTitle={res("authors_ContactInfoPage_RightsToDisclose_Phone")}
        rowValueLabelYes={res(
          "authors_ContactInfoPage_RightsToDisclose_PhoneLabelYes",
        )}
        rowValueLabelNo={res(
          "authors_ContactInfoPage_RightsToDisclose_PhoneLabelNo",
        )}
        isReadOnly={isReadOnly}
      />
      <AvisHorizontalChoice
        bag={bag}
        bagFieldIn="disclosureEmail"
        rowTitle={res("authors_ContactInfoPage_RightsToDisclose_Email")}
        rowValueLabelYes={res(
          "authors_ContactInfoPage_RightsToDisclose_EmailLabelYes",
        )}
        rowValueLabelNo={res(
          "authors_ContactInfoPage_RightsToDisclose_EmailLabelNo",
        )}
        isReadOnly={isReadOnly}
      />
      <AvisHorizontalChoice
        bag={bag}
        bagFieldIn="disclosureAddress"
        rowTitle={res("authors_ContactInfoPage_RightsToDisclose_Address")}
        rowValueLabelYes={res(
          "authors_ContactInfoPage_RightsToDisclose_AddressLabelYes",
        )}
        rowValueLabelNo={res(
          "authors_ContactInfoPage_RightsToDisclose_AddressLabelNo",
        )}
        isReadOnly={isReadOnly}
      />
    </AvisSection>
  );
}
